import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import Lottie from 'react-lottie';
import animationImage from './../../assets/image/hamburger-menu-2025.json';
import { useSpring, animated } from 'react-spring';
import { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { addCustomPathToLink, generateKey } from '../../functions';
import { ModalProvider } from '../Modal/modalContext';
import WishlistButton from '../Wishlist/WishlistButton';
import { hasWishlistItems } from '../../functions';
import { DataContext } from '../../views/pages/Root';

import styles from './MainNavigation.module.scss';

const HamburgerMenu = ({ menuArray }) => {
  const data = useContext(DataContext); //stare
  const [hamburgerMenuIsActive, setHamburgerMenuIsActive] = useState(false); //stare
  const [buttonIsActive, setButtonIsActive] = useState(false); //nowy
  const [catalogLink, setCatalogLink] = useState(null); //stare
  const [isWishlistEmpty, setIsWishlistEmpty] = useState([]); //stare
  var animState = true;
  var animInit = false;
  useEffect(() => {
    if (hamburgerMenuIsActive) {
      document.body.classList.add(`${styles.hideMove}`);
    } else {
      document.body.classList.remove(`${styles.hideMove}`);
    }
  }, [hamburgerMenuIsActive]);
  function animMenu(rewind) {
    //const startTime = Date.now();
    const menuLeftSide = document.querySelector('#leftMenu');
    const menuRightSide = document.querySelector('#rightMenu');
    const modalBackground = document.querySelector(`.${styles.modalBackground}`);
    const modalChildren = modalBackground.querySelectorAll('div');
    const listaBox = [];

    modalChildren.forEach((child) => {
      listaBox.push(child);
    });
    // console.log(listaBox);
    if (!rewind) {
      // console.log("dodaj global class");
      menuLeftSide.classList.add(`${styles.activeMenu}`);
      menuRightSide.classList.add(`${styles.activeMenu}`);
      // document.body.classList.add(`${styles.hideMove}`);
      setTimeout(function () {
        modalBackground.style.background = 'white';
      }, 1400);
    } else {
      // console.log("uusn gloabl class");
      menuLeftSide.classList.remove(`${styles.activeMenu}`);
      menuRightSide.classList.remove(`${styles.activeMenu}`);
      // document.body.classList.remove(`${styles.hideMove}`);
      modalBackground.style.background = 'transparent';
    }

    //if(animInit){
    // console.log("efect add");
    let interval = setInterval(() => {
      /*   const modalBackground = document.querySelector(`.${styles.modalBackground}`);
        const modalChildren = modalBackground.querySelectorAll('div'); */
      const randomIndex = Math.floor(Math.random() * listaBox.length);
      if (rewind) {
        // console.log("usune class");
        listaBox[randomIndex].classList.remove(`${styles.show}`);
      } else {
        // console.log("dodaj class");
        listaBox[randomIndex].classList.add(`${styles.show}`);
      }
      listaBox.splice(randomIndex, 1);
      if (listaBox.length == 0) {
        // console.log("clearInterval");
        clearInterval(interval);
      }
    }, 0.075);
    //setTimeout(function(){clearInterval(interval)},3000);
    /* }else{
      console.log("init efect");
      animInit = true;
    } */
  }

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationImage,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  //stare
  useEffect((_) => {
    // console.log("STARE useEffect");
    setCatalogLink(data?.staticData?.find((prop) => prop.name == 'catalogDownloadLink'));
  }, []);

  useEffect(() => {
    // console.log("WISH useEffect");
    setIsWishlistEmpty(!hasWishlistItems());
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    // console.log("SETHAMBUREGR");
    setHamburgerMenuIsActive(false);
  }, [pathname]);
  //stare

  // const handleSlideChange = (swiper) => {
  //   const swiperSlideActive = swiper.activeIndex;

  //   if (swiperSlideActive !== undefined) {
  //     const menuItems = document.querySelectorAll(`.${styles.mainItem}`);

  //     const matchingMenuItem = Array.from(menuItems).find((menuItem) => {
  //       return menuItem.getAttribute('data-id') == swiperSlideActive;
  //     });

  //     console.log("menuItems", menuItems);
  //     console.log("swiperSlideActive", swiperSlideActive);
  //     console.log("matchingMenuItem", matchingMenuItem);

  //     if (matchingMenuItem) {
  //       // matchingMenuItem.classList.add(styles.mainItemActiveCategory);
  //       matchingMenuItem.classList.add(styles.mainItemActive)
  //       const index = Array.from(menuItems).indexOf(matchingMenuItem);
  //       console.log("index", index);

  //       Array.from(menuItems).forEach((menuItem, i) => {
  //         if (i !== index) {
  //           menuItem.classList.remove(styles.mainItemActive);

  //         }
  //       });
  //     }
  //   }
  // };
  const handleSlideChange = (swiper) => {
    const swiperSlideActive = swiper.activeIndex;

    if (swiperSlideActive !== undefined) {
      const menuItems = document.querySelectorAll(`.${styles.mainItem}`);

      const matchingMenuItem = Array.from(menuItems).find((menuItem) => {
        return menuItem.getAttribute('data-id') == swiperSlideActive;
      });

      console.log('menuItems', menuItems);
      console.log('swiperSlideActive', swiperSlideActive);
      console.log('matchingMenuItem', matchingMenuItem);

      if (matchingMenuItem) {
        matchingMenuItem.classList.add(styles.mainItemActive);
        const index = Array.from(menuItems).indexOf(matchingMenuItem);
        console.log('index', index);

        Array.from(menuItems).forEach((menuItem, i) => {
          if (i !== index) {
            menuItem.classList.remove(styles.mainItemActive);

            // Usuwanie klasy aktywnego elementu dziecka
            // const parentKey = menuItem.getAttribute('data-key');
            // let nextSibling = menuItem.nextSibling;
            // while (nextSibling && nextSibling.hasAttribute('data-key') && nextSibling.getAttribute('data-key') === parentKey) {
            //   nextSibling.classList.remove(styles.menuChildItemActive);
            //   nextSibling = nextSibling.nextElementSibling;
            // }
          }
        });

        // Dodawanie klasy aktywnego elementu dziecka
        let nextSibling = matchingMenuItem.nextSibling;
        const parentKey = matchingMenuItem.getAttribute('data-key');
        while (nextSibling && nextSibling.hasAttribute('data-key') && nextSibling.getAttribute('data-key') === parentKey) {
          nextSibling.classList.add(styles.menuChildItemActive);
          nextSibling = nextSibling.nextElementSibling;
        }
      }
    }
  };

  return (
    <>
      {hamburgerMenuIsActive && <div className={styles.hamburgerOverlay} onClick={(_) => setHamburgerMenuIsActive(false)}></div>}
      <div className={styles.hamburgerWrapper}>
        <div className={styles.bgMobMenu}></div>
        <button
          className={`${hamburgerMenuIsActive ? styles.activeBtn : ''} ${styles.hamburgerMenuButton}`}
          onClick={(_) => {
            console.log('hamburgerMenuIsActive:', hamburgerMenuIsActive);

            if (hamburgerMenuIsActive) {
              const menu = document.querySelector('#logoMenu');
              menu.classList.remove('noBackgroundMenu');
              // console.log(menu);
              //schowaj menu
              if (animState) {
                animState = false;
                animMenu(true);
                setTimeout(function () {
                  animState = true;
                  setHamburgerMenuIsActive((prevState) => !prevState);
                }, 1600);
              }
            } else {
              animMenu(false);
              const menu = document.querySelector('#logoMenu');
              // console.log('test');
              menu.classList.add('noBackgroundMenu');
              //odpal menu
              setHamburgerMenuIsActive((prevState) => !prevState);
            }
          }}
        ></button>
        <div className={`${hamburgerMenuIsActive ? styles.activeHamburgerMenu : ''} ${styles.containerHam}`}>
          <div className={`${styles.modalBackground}`}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className={styles.leftSide} id="leftMenu">
            <ul className={styles.hamburgerMenu} id="menuHam">
              {menuArray}
            </ul>
            <div className={`${styles.bottomBtn} ${styles.desktop}`}>
              {/*{!!catalogLink && (
                <a href={catalogLink.link} aria-label="Pobierz katalog" target="_blank" className={styles.catalog}>
                  Pobierz Katalog
                </a>
              )}*/}
              <ModalProvider>
                <WishlistButton
                  customClassName={`${styles.wishlistButtonMenu} ${isWishlistEmpty ? '' : styles.wishlistButtonMenuActive}`}
                  onClickHandler={(_) => setHamburgerMenuIsActive(false)}
                >
                  Lista życzeń
                </WishlistButton>
              </ModalProvider>
            </div>
          </div>
          <div className={styles.rightSide} id="rightMenu">
            <figure className={styles.containerAnimationMenu}>
              <Lottie options={defaultOptions} />
            </figure>
            <div className={styles.containerHamSwiper}>
              {/* onSlideChange={handleSlideChange}  do swipera */}
              <Swiper
                id="menuSwiper"
                autoHeight={true}
                navigation={true}
                modules={[Navigation]}
                className={styles.swiperMenu}
                onSlideChange={handleSlideChange}
              >
                {menuArray
                  .filter((menuItem) => !menuItem.props.item.slug)
                  .map((menuItem, index) => (
                    <SwiperSlide key={index} data-key={menuItem.props.parentKey}>
                      {menuItem.props.item.slidertopinfo && <p className={styles.swiperSubTitle}>{menuItem.props.item.slidertopinfo}</p>}
                      {menuItem.props.item.slidercover && (
                        <img
                          className={styles.swiperImg}
                          src={`https://cms.katalog.leroymerlin.pl/magazyn/public/img/${menuItem.props.item.slidercover}`}
                          alt={menuItem.props.item.slidercover}
                        />
                      )}
                      {menuItem.props.item.name && menuItem.props.item.sliderlink && (
                        <a className={styles.swiperTitle} href={addCustomPathToLink(menuItem.props.item.sliderlink)}>
                          {menuItem.props.item.name}
                        </a>
                      )}
                      {menuItem.props.item.sliderdescription && <p className={styles.swiperDesc}>{menuItem.props.item.sliderdescription} </p>}
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
            <div className={styles.containerHamburgerBtnShop}>
              <a className={styles.hamburgerBtnShop} href="https://www.leroymerlin.pl/">
                Przejdź do e-sklepu
              </a>
            </div>
            <div className={`${styles.bottomBtn} ${styles.mobile}`}>
              {/* {!!catalogLink && (
                <a href={catalogLink.link} aria-label="Pobierz katalog" target="_blank" className={styles.catalog}>
                  Pobierz Katalog
                </a>
              )} */}
              <ModalProvider>
                <WishlistButton
                  customClassName={`${styles.wishlistButtonMenu} ${isWishlistEmpty ? '' : styles.wishlistButtonMenuActive}`}
                  onClickHandler={(_) => setHamburgerMenuIsActive(false)}
                >
                  Lista życzeń
                </WishlistButton>
              </ModalProvider>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default HamburgerMenu;
